module.exports = __webpack_public_path__ + "img/Pedalsure Innovation Machine.e47665e.svg";